import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Container, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';
import { useInView } from 'react-intersection-observer';

export default function CTASection() {
    const theme = useTheme();
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <Box
            id="contact"
            sx={{
                py: 12,
                background: 'white',
                position: 'relative',
                overflow: 'hidden',
                borderTop: `1px solid ${theme.palette.grey[200]}`,
            }}
        >
            {/* Animasyonlu arka plan öğeleri */}
            {Array.from({ length: 10 }).map((_, index) => (
                <Box
                    key={index}
                    component={motion.div}
                    sx={{
                        position: 'absolute',
                        width: Math.random() * 100 + 50,
                        height: Math.random() * 100 + 50,
                        borderRadius: '50%',
                        background: `rgba(${theme.palette.primary.main}, 0.05)`,
                        top: `${Math.random() * 100}%`,
                        left: `${Math.random() * 100}%`,
                    }}
                    animate={{
                        y: [0, Math.random() * 100 - 50],
                        x: [0, Math.random() * 100 - 50],
                        opacity: [0.1, 0.3, 0.1],
                    }}
                    transition={{
                        duration: Math.random() * 10 + 10,
                        repeat: Infinity,
                        repeatType: 'reverse',
                    }}
                />
            ))}

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={8}>
                        <motion.div
                            ref={ref}
                            initial={{ opacity: 0, x: -30 }}
                            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                            transition={{ duration: 0.5 }}
                        >
                            <Typography
                                variant="h3"
                                component="h2"
                                sx={{
                                    fontSize: { xs: '2rem', md: '3rem' },
                                    fontWeight: 700,
                                    mb: 3,
                                    color: theme.palette.secondary.main,
                                    textAlign: 'center',
                                }}
                            >
                                Pazaryerleri Sorularınızı Otomatik Yanıtlamaya Başlayın
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: { xs: '1rem', md: '1.2rem' },
                                    color: theme.palette.text.secondary,
                                    mb: 4,
                                    maxWidth: '800px',
                                }}
                            >
                                TrendAsist ile müşteri sorularını 7/24 otomatik yanıtlayarak satışlarınızı artırın, zamandan tasarruf edin ve müşteri memnuniyetini yükseltin.
                            </Typography>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            style={{ textAlign: 'center' }}
                        >
                            <Button
                                variant="contained"
                                size="large"
                                endIcon={<ArrowForwardIcon />}
                                component="a"
                                href="/#/register"
                                sx={{
                                    py: 2,
                                    px: 4,
                                    fontSize: '1.1rem',
                                    fontWeight: 600,
                                    backgroundColor: theme.palette.primary.main,
                                    color: 'white',
                                    borderRadius: '30px',
                                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                        transform: 'translateY(-5px)',
                                        boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)',
                                    },
                                    transition: 'transform 0.3s, box-shadow 0.3s',
                                    textDecoration: 'none',
                                }}
                            >
                                Hemen Başlayın
                            </Button>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: theme.palette.text.secondary,
                                    mt: 2,
                                }}
                            >
                                Kurulum için teknik bilgi gerekmez
                            </Typography>
                        </motion.div>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
} 